import { render, staticRenderFns } from "./PageEducatorInstitutionSponsoredStudentRead.vue?vue&type=template&id=1e59a172&scoped=true&"
import script from "./PageEducatorInstitutionSponsoredStudentRead.vue?vue&type=script&lang=js&"
export * from "./PageEducatorInstitutionSponsoredStudentRead.vue?vue&type=script&lang=js&"
import style0 from "./PageEducatorInstitutionSponsoredStudentRead.vue?vue&type=style&index=0&id=1e59a172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e59a172",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VRow})
